import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SurveyLanguage } from "../../../types/surveyLanguage";

type StateType = {
  showLoader: boolean;
  appColor: string;
  lang: SurveyLanguage | null;
  showErrorPage: boolean;
  errorCode: "404" | "500";
  logoUrl?: string;
  isLoading: boolean;
};

const initialState: StateType = {
  showLoader: false,
  appColor: "",
  lang: null,
  showErrorPage: false,
  logoUrl: undefined,
  errorCode: "404",
  isLoading: false,
};

const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    setShowLoader(state: StateType, action: PayloadAction<boolean>) {
      state.showLoader = action.payload;
    },
    setColor(state: StateType, action: PayloadAction<string>) {
      state.appColor = action.payload;
    },
    setLogoUrl(state: StateType, action: PayloadAction<string | undefined>) {
      state.logoUrl = action.payload;
    },
    setLang(state: StateType, action: PayloadAction<SurveyLanguage>) {
      state.lang = action.payload;
    },
    setShowError(state: StateType, action: PayloadAction<boolean>) {
      state.showErrorPage = action.payload;
    },
    setErrorCode(state: StateType, action: PayloadAction<"500" | "404">) {
      state.errorCode = action.payload;
    },
    setLoading(state: StateType, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export const { setErrorCode, setShowLoader, setColor, setLogoUrl, setLang, setShowError, setLoading } = utilsSlice.actions;
export default utilsSlice.reducer;
